export const CHARGE_OPTIONS = {
  ON_FINALIZE: 'ON_FINALIZE',
  MANUAL: 'MANUAL'
};
export const INVOICE_VALIDATION_ERRORS = {
  INVALID_DUE_DATE: 'INVALID_DUE_DATE',
  MISSING_CONTACT: 'MISSING_CONTACT',
  NOT_PAYMENTS_ACTIVATED: 'NOT_PAYMENTS_ACTIVATED',
  CREDIT_MEMO_SELECTED: 'CREDIT_MEMO_SELECTED'
};